import { Button, Typography } from '@sonnen/web-ui';
import { useAuth } from '@sonnen/web-utils/hooks';
import { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { useAppContext } from '../../AppContext/AppContext';
import { AppRoute } from '../../constants';
import { CurrentUser } from '../../graphql/generated';
import { useTranslation } from '../../i18n/i18n';
import { PageBackground } from '../../types';
import styles from './PageNotFound.module.css';

const PageNotFound = () => {
  const { user: authenticatedUser } = useAuth<CurrentUser>();
  const { t } = useTranslation();
  const { setCurrentBackground } = useAppContext();

  useEffect(() => {
    setCurrentBackground(PageBackground.HOME);
  }, [setCurrentBackground]);

  return (
    <div className={styles.notFoundPage} data-testid="not-found-page">
      <Typography.Body1 variant="on-colour">{t('pageNotFound.text')}</Typography.Body1>
      <Link
        to={authenticatedUser ? AppRoute.TARIFFS_COMPARISON : AppRoute.ROOT}
        data-testid="go-home-link"
      >
        <Button
          variant="tertiary"
          size="medium"
          onClick={undefined}
          dataTestId="go-home-btn"
          label={t('pageNotFound.backHomeLink')}
        />
      </Link>
    </div>
  );
};

export default PageNotFound;
